export default {
  UNID: { unit: "UNID", name: "UNIDADE", fractional: false },
  AMPOLA: { unit: "AMPOLA", name: "AMPOLA", fractional: false },
  BALDE: { unit: "BALDE", name: "BALDE", fractional: false },
  BANDEJ: { unit: "BANDEJ", name: "BANDEJA", fractional: false },
  BARRA: { unit: "BARRA", name: "BARRA", fractional: false },
  BISNAG: { unit: "BISNAG", name: "BISNAGA", fractional: false },
  BLOCO: { unit: "BLOCO", name: "BLOCO", fractional: false },
  BOBINA: { unit: "BOBINA", name: "BOBINA", fractional: false },
  BOMB: { unit: "BOMB", name: "BOMBONA", fractional: false },
  CX: { unit: "CX", name: "CAIXA", fractional: false },
  CX2: { unit: "CX2", name: "CAIXA COM 2 UNIDADES", fractional: false },
  CX3: { unit: "CX3", name: "CAIXA COM 3 UNIDADES", fractional: false },
  CX5: { unit: "CX5", name: "CAIXA COM 5 UNIDADES", fractional: false },
  CX10: { unit: "CX10", name: "CAIXA COM 10 UNIDADES", fractional: false },
  CX15: { unit: "CX15", name: "CAIXA COM 15 UNIDADES", fractional: false },
  CX20: { unit: "CX20", name: "CAIXA COM 20 UNIDADES", fractional: false },
  CX25: { unit: "CX25", name: "CAIXA COM 25 UNIDADES", fractional: false },
  CX50: { unit: "CX50", name: "CAIXA COM 50 UNIDADES", fractional: false },
  CX100: { unit: "CX100", name: "CAIXA COM 100 UNIDADES", fractional: false },
  CAPS: { unit: "CAPS", name: "CAPSULA", fractional: false },
  CART: { unit: "CART", name: "CARTELA", fractional: true },
  CM: { unit: "CM", name: "CENTIMETRO", fractional: true },
  CM2: { unit: "CM2", name: "CENTIMETRO QUADRADO", fractional: true },
  CENTO: { unit: "CENTO", name: "CENTO", fractional: true },
  CJ: { unit: "CJ", name: "CONJUNTO", fractional: false },
  DISP: { unit: "DISP", name: "DISPLAY", fractional: false },
  DUZIA: { unit: "DUZIA", name: "DUZIA", fractional: true },
  EMBAL: { unit: "EMBAL", name: "EMBALAGEM", fractional: false },
  FARDO: { unit: "FARDO", name: "FARDO", fractional: false },
  FOLHA: { unit: "FOLHA", name: "FOLHA", fractional: false },
  FRASCO: { unit: "FRASCO", name: "FRASCO", fractional: false },
  GALAO: { unit: "GALAO", name: "GALÃO", fractional: false },
  GF: { unit: "GF", name: "GARRAFA", fractional: false },
  GRAMAS: { unit: "GRAMAS", name: "GRAMAS", fractional: true },
  JOGO: { unit: "JOGO", name: "JOGO", fractional: false },
  KIT: { unit: "KIT", name: "KIT", fractional: false },
  LATA: { unit: "LATA", name: "LATA", fractional: false },
  LITRO: { unit: "LITRO", name: "LITRO", fractional: true },
  MWH: { unit: "MWH", name: "MEGAWATT HORA", fractional: true },
  M: { unit: "M", name: "METRO", fractional: true },
  M2: { unit: "M2", name: "METRO QUADRADO", fractional: true },
  M3: { unit: "M3", name: "METRO CÚBICO", fractional: true },
  MILHEI: { unit: "MILHEI", name: "MILHEIRO", fractional: false },
  ML: { unit: "ML", name: "MILILITRO", fractional: true },
  PACOTE: { unit: "PACOTE", name: "PACOTE", fractional: false },
  PALETE: { unit: "PALETE", name: "PALETE", fractional: false },
  PARES: { unit: "PARES", name: "PARES", fractional: false },
  PC: { unit: "PC", name: "PEÇA", fractional: false },
  POTE: { unit: "POTE", name: "POTE", fractional: false },
  K: { unit: "K", name: "QUILATE", fractional: false },
  KG: { unit: "KG", name: "QUILOGRAMA", fractional: true },
  RESMA: { unit: "RESMA", name: "RESMA", fractional: false },
  ROLO: { unit: "ROLO", name: "ROLO", fractional: false },
  SACO: { unit: "SACO", name: "SACO", fractional: false },
  SACOLA: { unit: "SACOLA", name: "SACOLA", fractional: false },
  TAMBOR: { unit: "TAMBOR", name: "TAMBOR", fractional: false },
  TANQUE: { unit: "TANQUE", name: "TANQUE", fractional: false },
  TON: { unit: "TON", name: "TONELADA", fractional: true },
  TUBO: { unit: "TUBO", name: "TUBO", fractional: false },
  VASIL: { unit: "VASIL", name: "VASILHAME", fractional: false },
  VIDRO: { unit: "VIDRO", name: "VIDRO", fractional: false }
};



// WEBPACK FOOTER //
// ./src/core/enum/unit-labels.enum.js